import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
// import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Sidebar from "../sidebar";
import profileImg from "../../../assets/images/profile.png";
import useMediaQuery from '@mui/material/useMediaQuery';
import {callByItems} from '../../../../constants'
import "./commonLayout.scss";
import NameLetter from "../nameLetter";


const CommonLayout = ({ children, candidateName = "Candidate Name",callBy=false ,appTheme=false}) => {

  const mobileMatches = useMediaQuery('(max-width:600px)');

  const [mobileOpen, setMobileOpen] = React.useState(true);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const drawerWidth = callBy== callByItems.widget ?'100%' : 360;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };
  const handleSelectUser = (user) => {
    // console.log("user -=====", user);
    setSelectedUser(user);
  };

  const drawer = (
    <>
      <Sidebar
      handleDrawerClose={handleDrawerClose}
      mobileOpen={mobileOpen}
      // onSelectUser={handleSelectUser}
      setMobileOpen={setMobileOpen}
      />
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {candidateName ? (
        <AppBar
          color="secondary"
          position="fixed"
          className={`layout-header ${callBy == callByItems.mobile ?'isApp':''} ${parseInt(appTheme) == 3 ?'dark-theme':''}`}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            boxShadow: 'none',
            borderBottom: '1px solid rgba(229, 229, 229, .52)'
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: "none" }, margin:0, position: 'absolute', left: '0', padding: '0', width: '40px', height: '40px', zIndex: '2' }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      ) : (
        ""
      )}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        {mobileMatches ? 
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: '100%',
            },
          }}
        >
          {drawer}
        </Drawer>
        :
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
        }

{/* <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={mobileOpen}
      >
        {drawer}
        </Drawer> */}
      </Box>
      <Box
        component="main"
        className={`chat-main  ${mobileOpen ? "chat-open" : "chat-close"} ${!candidateName && "no-header"}`}
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default CommonLayout;
